import axios, {AxiosError} from "axios";
import { API_URL, ChangeLicenseResponse, ErrorResponse, GetNumberResult } from "../constant";
import { RegisterResponse } from "../constant";
  
export async function UpdateWelcome(value: number): Promise<RegisterResponse> {
    const token = localStorage.getItem("token")
        
    const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token
        },
        validateStatus: (status: number) => {
            return status >= 200 && status < 500
        }
      };

    try {
        const response = await axios.post(
          `${API_URL}api/user/updatewelcome`,
          { value: value },
          config,
        );
    
        if (response.status === 204)
        {
            return { success: true, msg: "Update Welcome Status Success"};
        }
        else if (response.status === 409)
        {
            return { success: false, msg: response.data.detail || "Validation Error" };
        }
        else if (response.status === 422)
        {
            return { success: false, msg: "Validation Error" };
        }
        else{
            return { success: false, msg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, msg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, msg: "No response received from server" };
        } else {
            return { success: false, msg: `Error:, ${error.message}` };
        }
    }
}

export async function api_getNotice(): Promise<GetNumberResult> {
    const token = localStorage.getItem("token")
        
    const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token
        },
        validateStatus: (status: number) => {
            return status >= 200 && status < 500
        }
      };

    try {
        const response = await axios.post(
          `${API_URL}api/user/getNotice`,
          {},
          config,
        );

        if (response.status === 200)
        {
            return { success: true, ...response.data };
        }
        else if (response.status === 409)
        {
            return { success: false, errorMsg: response.data.detail || "Validation Error" };
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function api_updateWarning(value: number): Promise<RegisterResponse> {
    const token = localStorage.getItem("token")
        
    const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token
        },
        validateStatus: (status: number) => {
            return status >= 200 && status < 500
        }
      };

    try {
        const response = await axios.post(
          `${API_URL}api/user/updatewarning`,
          { value: value },
          config,
        );
    
        if (response.status === 204)
        {
            return { success: true, msg: "Update Warning Status Success"};
        }
        else if (response.status === 409)
        {
            return { success: false, msg: response.data.detail || "Validation Error" };
        }
        else if (response.status === 422)
        {
            return { success: false, msg: "Validation Error" };
        }
        else{
            return { success: false, msg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, msg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, msg: "No response received from server" };
        } else {
            return { success: false, msg: `Error:, ${error.message}` };
        }
    }
}